import RegularText from '@/components/RegularText';
import { DEFAULT_DATE_RANGE, NUMBER_REGEX } from '@/constants';
import { DateRangeType } from '@/constants/enum';
import { handleSaveShippingSettings, shippingSettingSelector } from '@/redux/slice/shipping.slice';
import { BlockStack, Box, Icon, InlineGrid, InlineStack, Select, TextField, Tooltip } from '@shopify/polaris';
import { InfoIcon } from '@shopify/polaris-icons';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

const ShippingDateRange = () => {
  const { t } = useTranslation('shippingSettings');
  const shippingSettings = useSelector(shippingSettingSelector);
  const dispatch = useDispatch();

  const handleChangeValue = (value: string) => {
    if (NUMBER_REGEX.test(value)) {
      dispatch(
        handleSaveShippingSettings({
          shippingDateRange: {
            ...shippingSettings.shippingDateRange,
            value: value,
          },
        }),
      );
    }
  };

  const handleChangeUnit = (value: string) => {
    dispatch(
      handleSaveShippingSettings({
        shippingDateRange: {
          ...shippingSettings.shippingDateRange,
          unit: value,
        },
      }),
    );
  };

  return (
    <BlockStack gap={'100'}>
      <InlineGrid columns="1fr auto" gap="100" alignItems="center">
        <TextField
          label={
            <InlineStack blockAlign="center" gap={'150'}>
              <RegularText>{t('visibleShippingDays.shippingDateRange.textDateRange')}</RegularText>
              <Tooltip content={t('visibleShippingDays.shippingDateRange.numberDayCustomerForeseeInstruction')} width="wide">
                <Box>
                  <Icon source={InfoIcon} />
                </Box>
              </Tooltip>
            </InlineStack>
          }
          value={shippingSettings?.shippingDateRange?.value}
          onChange={handleChangeValue}
          onBlur={() => {
            if (!Number(shippingSettings?.shippingDateRange?.value)) {
              dispatch(
                handleSaveShippingSettings({
                  shippingDateRange: {
                    ...shippingSettings.shippingDateRange,
                    value: DEFAULT_DATE_RANGE,
                  },
                }),
              );
            }
          }}
          autoComplete="off"
          type="text"
          helpText={t('visibleShippingDays.shippingDateRange.helpTextDateRange')}
          min={0}
        />
        <Select
          label=""
          options={[
            { label: t('visibleShippingDays.shippingDateRange.days'), value: DateRangeType.DAY },
            { label: t('visibleShippingDays.shippingDateRange.weeks'), value: DateRangeType.WEEK },
            { label: t('visibleShippingDays.shippingDateRange.months'), value: DateRangeType.MONTH },
          ]}
          onChange={handleChangeUnit}
          value={shippingSettings?.shippingDateRange?.unit}
        />
      </InlineGrid>
    </BlockStack>
  );
};

export default ShippingDateRange;
